import './QdAccordion.scss';
import template from './QdAccordion.vhtml';

export default {
	name: 'QdAccordion',
	template: template,
	props: {
		tabLabel: {
			type: String,
		},
		bodyHasTopPad: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		isOpen: false,
	}),
	computed: {
		tabClasses: vm => {
			let dynamicClasses = {
				'qd-accordion__tab--bottom-line': vm.isOpen,
			};

			return ['qd-accordion__tab', dynamicClasses];
		},
		tabIconInnerClasses: vm => {
			let dynamicClasses = {
				'qd-accordion__tab-icon-inner--rotated': vm.isOpen,
			};

			return ['qd-accordion__tab-icon-inner', dynamicClasses];
		},
		bodyClasses: vm => {
			let dynamicClasses = {
				'qd-accordion__body--has-top-pad': vm.bodyHasTopPad,
			};

			return ['qd-accordion__body', dynamicClasses];
		},
	},
	methods: {
		toggleVisibility() {
			this.isOpen = !this.isOpen;
		}
	},
};
